import Loader from 'authorization-module/lib/ui/atoms/Loader'
import { ReactNode, Suspense } from 'react'
import ErrorBoundary from 'ui/patterns/ErrorBoundary'

interface SuspenseRouteProps {
  children: ReactNode
}

const SuspenseRoute = ({ children }: SuspenseRouteProps) => (
  <ErrorBoundary>
    <Suspense fallback={<Loader />}>{children}</Suspense>
  </ErrorBoundary>
)

export default SuspenseRoute
